import { Link } from "react-router-dom";
import "./AboutContentStyle.css";
import pro1 from "../assets/services.png";
import pro2 from "../assets/about.png";

import React from 'react'

const AboutContent = () => {
  return (
    <div className="about">
        <div className="left">
            <h1>Who Am We</h1>
            <p>Ekreat Solution is a forward–thinking Information and Communication Technology (ICT) 
                    service provider dedicated to delivering reliable, innovative, and affordable digital 
                    solutions. see <Link to="./Projects">Projects</Link>. With a strong focus on excellence, 
                    we bridge the gap between technology and real–world needs by offering tailored solutions that 
                    empower individuals, businesses, and organizations to achieve more.</p>
        <Link to="/contact">
        <botton className="btn">Contact
            </botton></Link>
            </div>
        <div className="right">
            <div className="img-container">
                <div className="img-stack top">
                    <img src={pro1} className="img" alt="true" />
                </div>
                <div className="img-stack bottom">
                    <img src={pro2} className="img" alt="true" />
                </div>
            </div>
        </div>
    </div>
  )
}

export default AboutContent;